const getSubscriptionDeliveryIntervals = (serverLineItem, subscriptionIntervalsFallback, isAvailableForSubscription, isSubscription)=>{
    const { variant  } = serverLineItem;
    if (!isAvailableForSubscription || isSubscription) {
        return undefined;
    }
    const subscriptionIntervalsProductData = 'variantTypeDetails' in variant ? variant.variantTypeDetails.subscriptionIntervals : undefined;
    const subscriptionIntervals = (subscriptionIntervalsProductData === null || subscriptionIntervalsProductData === void 0 ? void 0 : subscriptionIntervalsProductData.length) ? subscriptionIntervalsProductData : subscriptionIntervalsFallback;
    if ((subscriptionIntervals === null || subscriptionIntervals === void 0 ? void 0 : subscriptionIntervals.length) === 0 || !subscriptionIntervals) {
        console.error(`Product is available for subscription but has no valid delivery intervals or fallback configured. sku: ${variant.sku}`);
        return undefined;
    }
    return subscriptionIntervals;
};

export { getSubscriptionDeliveryIntervals };
//# sourceMappingURL=get-subscription-delivery-intervals.js.map
